// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:29Z                      #

// ##############################################################


/**
 * 
 */
enum TypeSign {
    CUSTOM = 'CUSTOM', 
    SIGN_COMBINATION = 'SIGN_COMBINATION', 
    NO_SIGN = 'NO_SIGN'
};
export default TypeSign;

